module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/4/4-fe21d4335ccbf0ef0f8353f491605896.jpg";